















import { Component, Prop, Vue } from "vue-property-decorator";
import { Tool } from "@/types";

@Component
export default class Tools extends Vue {
  @Prop() tools!: Array<Tool>;
  get getSortedTools() {
    return this.tools.sort(function(a, b) {
  const nameA = a.name.toUpperCase();
  const nameB = b.name.toUpperCase();
  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }

  return 0;
});
  }
}
